import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchPaymentSessionStatus } from '../../http/userAPI';
import { Context } from "../../index";
import { ADD_FUNDS_TO_USD_BALANCE_ROUTE, USER_DASHBOARD_ROUTE } from "../../utils/consts";
import { Button, Card, Col, Row } from "react-bootstrap";
import Loader from "../Loader";

const AddFundsReturn = () => {
    const [status, setStatus] = useState(null);
    const [customerEmail, setCustomerEmail] = useState('');
    const [selectedPrice, setSelectedPrice] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { user } = useContext(Context);

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const sessionId = urlParams.get('session_id');

                if (sessionId) {
                    const data = await fetchPaymentSessionStatus(sessionId);
                    if (data) {
                        setStatus(data.status);
                        setCustomerEmail(data.customer_email);
                        setSelectedPrice(data.amount_total / 100);
                    }
                }
            } catch (error) {
                console.error('Status Payment Error:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchStatus();
    }, []);

    // Пока загружается
    if (loading) return <Loader />;

    // Если сессия открыта — редирект
    if (status === 'open') {
        navigate(ADD_FUNDS_TO_USD_BALANCE_ROUTE);
        return null;
    }

    // Если оплата завершена
    if (status === 'complete') {
        return (
            <Row className="justify-content-center">
                <Col md={12} className="text-center mb-4">
                    <h3>Congratulations, Payment Successful!</h3>
                    <Button
                        variant="success"
                        className="mt-3 mb-4"
                        onClick={() => navigate(USER_DASHBOARD_ROUTE)}
                    >
                        <strong>Go to Customer Dashboard</strong>
                    </Button>

                    <Card
                        className="shadow-lg"
                        style={{
                            borderRadius: "8px",
                            width: "60vw",
                            maxWidth: "600px",
                            padding: "10px",
                            margin: "0 auto",
                        }}
                    >
                        <Card.Body className="text-start">
                            <p>
                                Thank you for your purchase — your <strong>${selectedPrice}</strong> payment has been processed successfully.
                                Funds have been added to your USD balance.
                            </p>
                            <p>
                                If you have any questions or need help, our support team is here for you.
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        );
    }

    return <div className="text-center py-5">Something went wrong. Please try again.</div>;
};

export default AddFundsReturn;
